import { forwardRef, type Ref, type SVGProps } from "react";
const IconFingerDrawOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M14 4a2 2 0 0 1 2 2v8.271l9.275 1.181a2 2 0 0 1 1.71 2.23L25.694 28H14a2 2 0 0 1-.35-.036l-.116-.026a3 3 0 0 1-.279-.092l-.092-.036c-.069-.033-8.235-5.123-8.235-5.123a2 2 0 0 1 .622-3.638 3 3 0 0 1 .65-.079 1.6 1.6 0 0 1 .865.225L12 21.829V6a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4v12.5l-1.88-1a3.6 3.6 0 0 0-1.92-.53 5 5 0 0 0-1.1.13 4 4 0 0 0-1.22 7.29l8 5a.04.04 0 0 0 .03.01 4 4 0 0 0 .51.27.5.5 0 0 0 .11.04 5 5 0 0 0 .56.18c.07.01.13.03.19.04A4.3 4.3 0 0 0 14 30h11.69a2.01 2.01 0 0 0 1.99-1.75l1.29-10.32a4 4 0 0 0-3.43-4.46L18 12.51V6a4 4 0 0 0-4-4m15.005 8a1 1 0 0 1-.857-.483A9.97 9.97 0 0 0 20 5a1 1 0 0 1 0-2 12.01 12.01 0 0 1 9.858 5.485A1 1 0 0 1 29.005 10" />
  </svg>
);
const ForwardRef = forwardRef(IconFingerDrawOutlineSVG);
ForwardRef.displayName = "IconFingerDrawOutline";
export { ForwardRef as IconFingerDrawOutline };
